import { RequestStatementPrintBatchMutation } from "~/gql/mutations/customerStatements.generated";
import { GetStatementPrintBatchQuery } from "~/gql/queries/customerStatements.generated";

export const customerStatementsEndpoints = {
	GetStatementPrintBatch: {
		providesTags: ["StatementPrintBatch"] as AddTagTypes,
		transformResponse: (res: GetStatementPrintBatchQuery) => res
	},
	RequestStatementPrintBatch: {
		invalidatesTags: ["StatementPrintBatch"] as AddTagTypes,
		transformResponse: (res: RequestStatementPrintBatchMutation) => res
	}
};
